module.exports = __webpack_public_path__ + "img/cons_4.e2428184.jpg";